import type { Step } from "react-joyride";

export const districtFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມສ້າງ/ແກ້ໄຂເມືອງ. ເລືອກແຂວງ, ຕື່ມຊື່ 3 ພາສາ (ລາວ, ไทย, EN), ສະຖານະ ແລະ ລຳດັບ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="geo-form-province"]',
    content: "ເລືອກແຂວງ — ບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-form-nameLo"]',
    content: "ຊື່ພາສາລາວ — ບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-form-enabled"]',
    content: "ເປີດສະແດງໃນ dropdown checkout/shipping ຫຼືບໍ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-form-submit"]',
    content: "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
